import ls from '../../services/ls'
import authService from '../../services/auth'
// import axios from 'axios'
import api from '../../services/api'
// initial state
const state = () => ({
    status: '',
    token: ls.get('token') || '',
    Authuser : {}
})

// getters
const getters = {
    isLoggedIn: state => !!state.token,
    authStatus: state => state.status,
    authUser: state => state.Authuser,
}
// actions
const actions = {
    login({commit}, user){
        return new Promise((resolve, reject) => {
          commit('auth_request')
          authService.postLogin(user)
          .then(resp => {
            const token = resp.data.token
            const auth={
              token:resp.data.token,
              user:resp.data.user
            }
            ls.set('token', token)
            ls.set('isLoggedIn', true)
            ls.set('_u_unique', resp.data.user.id)
            ls.set('_u_unique_id', resp.data.user.unique_id)
            ls.set('_u_name', resp.data.user.first_name+' '+resp.data.user.last_name)
            ls.set('_u_email', resp.data.user.email)
            ls.set('_u_mobile', resp.data.user.mobile_no)
            ls.set('_u_service', resp.data.user.company_name)
            ls.set('_u_p_im', resp.data.img_path)
            commit('auth_success', auth)
            // api.defaults.headers.common['Authorization'] = token
            resolve(resp)
          })
          .catch(err => {
            commit('auth_error')
            ls.remove('token')
            reject(err)
          })
        })
    },
    AutoLogin({commit},params){
      return new Promise((resolve, reject) => {
        commit('auth_request')
        authService.postAutoLogin(params)
        .then(resp => {
          const token = resp.data.token
          const auth={
            token:resp.data.token,
            user:resp.data.user
          }
          ls.set('token', token)
          ls.set('isLoggedIn', true)
          ls.set('_u_unique', resp.data.user.id)
          ls.set('_u_name', resp.data.user.first_name+' '+resp.data.user.last_name)
          ls.set('_u_p_im', resp.data.img_path)
          ls.set('_u_email', resp.data.user.email)
          ls.set('_u_mobile', resp.data.user.mobile_no)
          ls.set('_u_service', resp.data.user.company_name)
          commit('auth_success', auth)
          api.defaults.headers.common['Authorization'] = token
          resolve(resp)
        })
        .catch(err => {
          commit('auth_error')
          ls.remove('token')
          reject(err)
        })
      })
    },
    logout({commit}){
      return new Promise((resolve) => {
        commit('logout')
        ls.remove('token')
        ls.remove('isLoggedIn')
        ls.remove('_u_unique_id')
        ls.remove('_u_unique')
        ls.remove('_u_p_im')
        ls.remove('_u_email')
            ls.remove('_u_mobile')
            ls.remove('_u_service')
        authService.logout();
        delete api.defaults.headers.common['Authorization']
        resolve()
      })
    }
}

// mutations
const mutations = {
    auth_request(state){
        state.status = 'loading'
      },
      auth_success(state, auth){
        state.status = 'success'
        state.token = auth.token
        state.Authuser = auth.user
      },
      auth_error(state){
        state.status = 'error'
      },
      logout(state){
        state.status = ''
        state.token = ''
      },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}